import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MailIcon } from 'lucide-react';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      // In a real app, this would send to an API
      setTimeout(() => {
        setEmail('');
        setIsSubmitted(false);
      }, 3000);
    }
  };
  return <section className="py-24 bg-vita-cream relative overflow-hidden" data-id="element-197">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-198">
        <div className="absolute -top-24 -left-24 w-64 h-64 bg-vita-peach rounded-full mix-blend-multiply filter blur-3xl opacity-60" data-id="element-199"></div>
        <div className="absolute -bottom-24 -right-24 w-80 h-80 bg-vita-green-light rounded-full mix-blend-multiply filter blur-3xl opacity-60" data-id="element-200"></div>
      </div>

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-softer shadow-vita p-8 md:p-12 border border-vita-border/50" data-id="element-202">
          <div className="w-16 h-16 bg-vita-orange-pale rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-203">
            <MailIcon className="w-8 h-8 text-vita-orange" data-id="element-204" />
          </div>

          <h2 className="text-3xl font-bold text-vita-green-deep mb-4 font-heading" data-id="element-205">
            Neue Artikel & Insights erhalten
          </h2>

          <p className="text-vita-text-muted mb-8 max-w-lg mx-auto" data-id="element-206">
            Trage dich ein und erhalte unsere neuesten Artikel, Tipps und
            Inspirationen direkt in dein Postfach.
          </p>

          <form onSubmit={handleSubmit} className="max-w-md mx-auto" data-id="element-207">
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-208">
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="Deine E-Mail-Adresse" className="flex-grow px-5 py-3.5 rounded-full border border-vita-border focus:outline-none focus:ring-2 focus:ring-vita-green-sage focus:border-transparent transition-shadow bg-vita-cream/50" aria-label="E-Mail-Adresse" data-id="element-209" />
              <button type="submit" disabled={isSubmitted} className="px-8 py-3.5 bg-vita-green-deep text-white font-medium rounded-full hover:bg-vita-green-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-vita-green-deep transition-colors disabled:opacity-70 disabled:cursor-not-allowed whitespace-nowrap" data-id="element-210">
                {isSubmitted ? 'Angemeldet ✓' : 'Anmelden'}
              </button>
            </div>
            <p className="mt-4 text-xs text-vita-text-light" data-id="element-211">
              Kein Spam. Jederzeit abmeldbar.
            </p>
          </form>
        </motion.div>
      </div>
    </section>;
}